<template>
  <el-col :span="24">
    <el-card>
      <el-row>
        <el-col :span="24">
          <span class="flex-item">
            日期：
            <el-date-picker format="yyyy-MM-dd 00:00:00" value-format="yyyy-MM-dd 00:00:00" v-model="query.startTime" placeholder="选择日期"></el-date-picker>&nbsp;-
            <el-date-picker format="yyyy-MM-dd 23:59:59" value-format="yyyy-MM-dd 23:59:59" v-model="query.endTime" placeholder="选择日期"></el-date-picker>
          </span>
          <span class="flex-item">
            <el-button type="primary" icon="el-icon-search" class="flex-item" @click="search">查询</el-button>
          </span>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="ul-margin">
      <el-row>
        <el-table border :data="list.rows" :height="tableH " highlight-current-row style="width:98%">
          <el-table-column label="序号" type="index" width="80" align="center">
            <template slot-scope="scope">
              <span>{{(list.pageNumber - 1) * list.pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
          <el-table-column prop="sexStr" label="性别" width="120" align="center"></el-table-column>
          <el-table-column prop="degreeName" label="学位" width="120" align="center"></el-table-column>
          <el-table-column prop="unitName" label="单位" width="200" align="center"></el-table-column>
          <el-table-column prop="postName" label="行政职务" width="120" align="center"></el-table-column>
          <el-table-column prop="techTitleName" label="职称" width="120" align="center"></el-table-column>
          <el-table-column prop="isSXD" label="省学带" width="80" align="center">
            <template #default="{row}">{{row.isSXD?'是':'否'}}</template>
          </el-table-column>
          <el-table-column prop="isBD" label="博导" width="80" align="center">
            <template #default="{row}">{{row.isBD?'是':'否'}}</template>
          </el-table-column>
          <el-table-column prop="auditStatusStr" label="审核状态" width="150" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="175" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <div class="flex-container flex-space-around">
                <el-button type="text" title="查看" icon="el-icon-search" size="small" @click="select(row)">查看</el-button>
                <el-button type="text" title="审核" icon="el-icon-s-check" size="small" @click="$refs.expertAudit.openHandle(row)">审核</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="center" class="ul-page-margin">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="query.pageNumber"
          :page-sizes="[25, 50, 100, 200]"
          :page-size="query.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total"
        ></el-pagination>
      </el-row>
    </el-card>
    <el-dialog :visible.sync="dialog" width="950px" :destroy-on-close="true" top="10vh" :before-close="closeHandle" :close-on-click-modal="false">
      <transition name="el-fade-in">
        <ExpertApplyForm :id="currentData.id" v-if="dialog" class="transition-box" />
      </transition>
    </el-dialog>
    <ExpertAudit ref="expertAudit" @search="search" />
  </el-col>
</template>

<script>
import ExpertApplyForm from '@/components/ExpertApplyForm';
import axios from 'axios';
import ExpertAudit from './ExpertAudit';
export default {
  name: 'ExpertAuditList',
  components: { ExpertApplyForm, ExpertAudit },
  data () {
    return {
      characterInfo: [],
      list: {
        rows: []
      },
      query: {
        pageNumber: 1,
        pageSize: 25,
        // startTime: this.$nstand.startTime(-365),
        // endTime: this.$nstand.endTime(0),
        startTime: this.getTime('start'),
        endTime: this.getTime('end'),
      },
      tableH: window.innerHeight - 220,
      currentData: {},
      dialog: false
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    // 查看按钮
    select (row) {
      this.currentData = row;
      this.dialog = true;
    },
    closeHandle () {
      this.currentData = {};
      this.dialog = false;
    },
    // 查询
    search () {
      this.$nstand.ajax(
        {
          method: 'get',
          url: '/api/Expert/GetAuditList',
          params: {
            ...this.query
          },
          success: response => {
            if (response.data.success) {
              this.$set(this, 'list', response.data.data);
            }
          }
        },
        true
      );
    },
    getTime (val) {
      var sTime = new Date()
      let year = sTime.getFullYear()
      let time = ''
      if (val === 'start') {
        time = year + '-01-01 00:00:00'
      } else {
        time = year + '-12-31 23:59:59'
      }
      return time
    },
    // 修改表单按钮
    modify (row) {
      const { id } = row
      this.$router.push({ path: '/expert/apply', query: { id } })
    },
    //size改变
    handleSizeChange: function (sizes) {
      this.$set(this.query, 'pageSize', sizes);
      this.search();
    },
    //当前页改变
    handleCurrentChange: function (current) {
      this.$set(this.query, 'pageNumber', current);
      this.search();
    }
  }
};
</script>

<style>
.ul-margin {
  margin-top: 0.5em;
}
.ul-input-width {
  width: 15.7em;
}
.ul-span-margin {
  margin-left: 1em;
}
.ul-button-width {
  width: 7em;
}
.ul-select-width {
  width: 13em;
  margin-left: 0.5em;
}
.ul-page-margin {
  margin-top: 1em;
}
</style>
